import { IDoctor } from '@alberta/konexi-shared';
import { DoctorDB } from 'src/app/common/repository/databases';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { PrescriptionChainHandler } from './prescription-chain-handler';

export class DoctorHandler extends PrescriptionChainHandler {
  constructor(private _queryService: QueryService) {
    super();
  }
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const doctor = await this._queryService.get<IDoctor>(request.doctorId, DoctorDB);
    if (doctor) {
      let name = `${doctor.title ? doctor.title + ' ' : ''}${doctor.firstName} ${doctor.lastName}`;
      if (doctor.draft) {
        const title = doctor.draft.title ? doctor.draft.title : doctor.title;
        const firstName = doctor.draft.firstName ? doctor.draft.firstName : doctor.firstName;
        const lastName = doctor.draft.lastName ? doctor.draft.lastName : doctor.lastName;
        name = `${title ? title + ' ' : ''}${firstName} ${lastName}`;
      }
      prescriptionRequestDto.doctor = {
        name: name,
        additionalName: '',
        address: doctor.draft?.address ? doctor.draft.address : doctor.address,
        postalCode: doctor.draft?.postalCode ? doctor.draft.postalCode : doctor.postalCode,
        city: doctor.draft?.city ? doctor.draft.city : doctor.city,
        ...(doctor.lifelongNumber && { lifelongNumber: doctor.lifelongNumber }),
      };
    }
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
